import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';

type PaginatorLabels = {
  itemsPerPage: string;
  nextPage: string;
  previousPage: string;
  firstPage: string;
  lastPage: string;
  of: string;
};

const LABELS: Record<string, PaginatorLabels> = {
  en: { itemsPerPage: 'Items per page', nextPage: 'Next page', previousPage: 'Previous page', firstPage: 'First page', lastPage: 'Last page', of: 'of' },
  fr: { itemsPerPage: 'Éléments par page', nextPage: 'Page suivante', previousPage: 'Page précédente', firstPage: 'Première page', lastPage: 'Dernière page', of: 'sur' },
  tn: { itemsPerPage: 'Éléments par page', nextPage: 'Page suivante', previousPage: 'Page précédente', firstPage: 'Première page', lastPage: 'Dernière page', of: 'sur' },
  ar: { itemsPerPage: 'عناصر في الصفحة', nextPage: 'الصفحة التالية', previousPage: 'الصفحة السابقة', firstPage: 'الصفحة الأولى', lastPage: 'الصفحة الأخيرة', of: 'من' },
  tr: { itemsPerPage: 'Sayfa başına öğe', nextPage: 'Sonraki sayfa', previousPage: 'Önceki sayfa', firstPage: 'İlk sayfa', lastPage: 'Son sayfa', of: '/' },
};

@Injectable()
export class TranslatedPaginatorIntl extends MatPaginatorIntl {
  private labels = LABELS.en;

  constructor(transloco: TranslocoService) {
    super();
    this.setLabels(transloco.getActiveLang());
    transloco.langChanges$.subscribe((lang) => this.setLabels(lang));
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) return `0 ${this.labels.of} ${length}`;
    const start = page * pageSize;
    const end = Math.min(start + pageSize, length);
    return `${start + 1} – ${end} ${this.labels.of} ${length}`;
  };

  private setLabels(lang: string): void {
    this.labels = LABELS[lang] ?? LABELS.en;
    this.itemsPerPageLabel = this.labels.itemsPerPage;
    this.nextPageLabel = this.labels.nextPage;
    this.previousPageLabel = this.labels.previousPage;
    this.firstPageLabel = this.labels.firstPage;
    this.lastPageLabel = this.labels.lastPage;
    this.changes.next();
  }
}
